import {
  faArrowDownWideShort,
  faArrowUpWideShort
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dropdown } from '~/components/Form'
import { quickSortIcon, quickSortWrapper } from './QuickSortControl.css'

type SortDirection = 'asc' | 'desc'

type SortOption = {
  label: string
  value: string
}

type QuickSortControlProps = {
  sort: string
  sortDirection: SortDirection
  options: SortOption[]
  onChange: (next: { sort?: string; sortDirection?: SortDirection }) => void
  asMenu?: boolean
}

export const QuickSortControl = ({
  sort,
  sortDirection,
  options,
  onChange,
  asMenu = false
}: QuickSortControlProps) => {
  return (
    <div className={quickSortWrapper}>
      <Dropdown
        asMenu={asMenu}
        options={options}
        required
        defaultValue={sort}
        small={true}
        onChange={(value) => onChange({ sort: value })}
        placeholder="Tri"
      />
      <div className={quickSortIcon}>
        <FontAwesomeIcon
          icon={
            sortDirection === 'desc' ? faArrowUpWideShort : faArrowDownWideShort
          }
          onClick={() =>
            onChange({
              sortDirection: sortDirection === 'asc' ? 'desc' : 'asc'
            })
          }
        />
      </div>
    </div>
  )
}
